<template>
  <div>
    <b-row style="margin-bottom: 50px">
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
        @selection-changed="onSelectionChanged"
      >
      </ag-grid-vue>
    </b-row>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import StokAktarSecButon from "./StokAktarSecButon.vue";
import state from "../../../../store/state";
import Store from "../../../../store/store";
export default {
  props: ["StokAktarList"],
  components: {
    StokAktarSecButon,
    AgGridVue,
  },
  data() {
    return {
      rowSelection: null,
      localeText: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowData: [],
      barkod: "",
      selectedRows: [],
      colorAlert: "primary",
    };
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    
  },

  methods: {
    
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();

      this.$vs.dialog({
        color: this.colorAlert,
        title: "Uyarı", //`Dialog - ${this.colorAlert}`,
        text: "Stok aktarılıyor emin misiniz ?",
        acceptText: "Gönder",
        accept: this.StokAktar,
      });
    },
    StokAktar() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "N11",
        token: Store.state.tokenId,
        kategoriId: vm.selectedRows[0].categoryId,
        katalogId: vm.selectedRows[0].catalogId,
        barkod: vm.barkod,
      };
      soap.createClient(url, function (err, client) {
        client.pazaryeriKatalogGuncelle(args, function (err, result) {
          if (result.pazaryeriKatalogGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.pazaryeriKatalogGuncelleResult);

          
          if(vm.veriler.response == "Ok"){
             vs.notify({
              title: "Başarılı",
              text: "Ürün gönderimi başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.$root.$emit("stokaktarpopup");
          }else{
            vs.notify({
              title: "Hata",
              text: "Ürün gönderiminde hata var",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    listele(barkod) {
      var vm = this;
      vm.rowData = Store.state.uzum.stokAktarList
      vm.barkod = barkod;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "StokAktarSecButon",
      },
      {
        headerName: "Kategori Adı",
        field: "categoryName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ürün Adı",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "productTitle",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>